import type { SVGProps } from "react";

export const MissedLocationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 19C11.1667 19 10.4583 18.7083 9.875 18.125C9.29167 17.5417 9 16.8333 9 16C9 15.1667 9.29167 14.4583 9.875 13.875C10.4583 13.2917 11.1667 13 12 13C12.8333 13 13.5417 13.2917 14.125 13.875C14.7083 14.4583 15 15.1667 15 16C15 16.8333 14.7083 17.5417 14.125 18.125C13.5417 18.7083 12.8333 19 12 19Z"
      fill={props.fill}
    />
    <path
      d="M16.2105 12.0789L15.0105 10.9L16.7789 9.13158H4V7.44737H16.7789L15.0316 5.67895L16.2316 4.5L20 8.28947L16.2105 12.0789Z"
      fill={props.fill}
    />
  </svg>
);
